import { Button, Form, InputNumber, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import useSalesTeamAPI from '../apis/salesTeamAPI';
import EventEmitter from '../../utils/eventEmitter';



const SalesTeamChanges = () => {
  const {products, salesTeam} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(salesTeam.name ? salesTeam.name : '');
  const { create, update } = useSalesTeamAPI();
  

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['id'] = salesTeam.id;
    update(salesTeam.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };

  useEffect(() => {
    EventEmitter.subscribe('sales_team_response', data => {
      navigate('/sales/teams/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('sales_team_response');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/sales/teams'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Sales Teams</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ salesTeam.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {salesTeam.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Sales Team Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 4 }}
          labelWrap={true}
          initialValues={salesTeam.seo ? salesTeam : {
            invoice_target: 0
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Badge style={{width: '340px'}} className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3 ">Team Details</Badge>
          <Form.Item label='Team Leader' name='team_leader_id' className='font-semibold text-gray-800 mb-4' required >
            <Select options={[]} style={{width: '200px'}}/>
          </Form.Item>
          <Form.Item label='Invoicing Target' name='invoice_target' className='font-semibold text-gray-800 mb-4' required >
            <InputNumber style={{width: '200px'}} className='font-normal'/>
          </Form.Item>
          {/* <Tabs 
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'Team Members',
                children: 
                  <></>
              }
            ]}
          /> */}
        </Form>
      </div>
    </div>
  )
}

export default SalesTeamChanges;